module.exports = __webpack_public_path__ + "assets/img/ic-make-hover.6b1e3d12.svg";